export default __webpack_public_path__ + "static/media/bell.a8831f96.svg";